import { Component, ElementRef, inject, Output, PLATFORM_ID } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MailService } from '../../services/mail/mail.service';
import { EventEmitter } from '@angular/core';

export enum ComponentState {
  Form = 'form',
  Loading = 'loading',
  Success = 'success',
  Error = 'error'
}

@Component({
    selector: 'app-contact',
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule
    ],
    templateUrl: './contact.component.html',
    styleUrl: './contact.component.less'
})
export class ContactComponent {

  private mailService = inject(MailService);
  private el = inject(ElementRef);
  private platformId = inject(PLATFORM_ID);

  ComponentState = ComponentState;
  currentState = ComponentState.Form;

  showRecaptcha = false;
  captchaKey = environment.CAPTCHA_KEY;

  isShow: boolean = false;

  language: string = 'es';

  @Output() showTerms: EventEmitter<void> = new EventEmitter<void>();
  @Output() showPolicy: EventEmitter<void> = new EventEmitter<void>();

  contactForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    description: new FormControl('', Validators.required),
    terms: new FormControl(false, Validators.requiredTrue),
  });

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const url = window.location.href;
      const urlParts = url.split('/');
      const lan = urlParts[3];
      this.language = lan === 'en' ? 'en' : 'es';
    }
   }

  submitForm() {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
    this.currentState = ComponentState.Loading;
    this.contactForm.disable();

    this.mailService.sendEmail(
      this.contactForm.controls['name'].value as string, 
      this.contactForm.controls['email'].value  as string, 
      this.contactForm.controls['description'].value as string, 
      (success) => {
       if (success) {
         this.currentState = ComponentState.Success;
       }else {
         this.currentState = ComponentState.Error;
       }
    });
  }

  showTermsAndConditions() {
    this.showTerms.emit();
  }

  showPrivacyPolicy() {
    console.log('showPrivacyPolicy');
    this.showPolicy.emit();
  }

}
